export const DOSAGE_TO_QUANTITY_GAP = '32px';
export const DOSAGE_TO_QUANTITY_MIN_GAP = '16px';
export const QUANTITY_TO_TREATMENT_DAYS_GAP = '8px';
export const QUANTITY_WIDTH = '70px';
export const AFTER_ISSUED_FROM_WIDTH = '192px';
export const ISSUED_FROM_TO_AFTER_ISSUED_FROM_GAP = '16px';
export const TEXT_VIEW_LABEL_TO_CONTENT_GAP = '4px';
